window.tp = window.tp || [];

window.tp.push([
    'addHandler',
    'loginSuccess',
    async function (data) {
        window.ats.start({
            "email": data.params.email
        });
    },
  ]);


const atsScript = document.createElement('script');
atsScript.onload = function () {
    window.ats.start({
        "placementID": 13375,
        "storageType": "localStorage",
        "detectionType": "URL",
        "logging": "debug",
        "pixelID": 711234
    });
};
atsScript.src = 'https://ats.rlcdn.com/ats.js';
document.head.appendChild(atsScript);

window.tp.push([
    'init',
    async function() {
        if (!window.tp.pianoId.isUserValid()) return;
        window.ats.start({"email": window.tp.pianoId.getUser().email})
    }
])